import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchFloorListResponse>}
 */
export function requestFloorList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/floor`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/floor?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
